import { Chip, Grid } from "@mui/material";
import ProductChipsHistories from "../../utils/ProductChips";

const ProductChipDashboard = ({ product, products, userData, displayToCard }: any) => {
  const cfg = ProductChipsHistories.find((p) => p.id === product);
  if (!cfg) return null;

  // IGNORA itens que não possuem balanceKey (ex.: "all")
  if (!cfg.balanceKey || !cfg.countCompanyKey || !cfg.countUserKey) {
    return null;
  }

  const colheitadeiraCinza = require('../../images/colheitadeiraCinza.png');
  const colheitadeiraBranca = require('../../images/colheitadeiraBranca.png');
  const colheitadeiraPreta = "https://img.icons8.com/material-rounded/96/harvester.png";

  const balance = userData.plan_balance[cfg.balanceKey];
  const count = userData.company_id
    ? userData.plan_balance[cfg.countCompanyKey]
    : userData.plan_balance[cfg.countUserKey];

  const isPlan2 = userData.plan_balance.plan === "2";
  const reachedLimit = balance < count;

  let icon;

  if (cfg.isHarvester) {
    icon = (
      <img
        width="14"
        src={
          isPlan2 && balance < 1
            ? colheitadeiraCinza
            : reachedLimit
            ? colheitadeiraPreta
            : colheitadeiraBranca
        }
        alt="harvester"
      />
    );
  } else {
    icon =
      typeof cfg.icon === "function"
        ? cfg.icon("#fff", false, true)
        : cfg.icon;
  }

  return (
    <Grid item md={12 / products.length} sm={12} xs={12}>
        <Chip
          icon={icon}
          label={`${count} consultas realizadas de ${balance}`}
          color={reachedLimit ? "warning" : "info"}
          sx={{ marginTop: 1 }}
          style={{ display: displayToCard }}
        />
    </Grid>
  );
};

export default ProductChipDashboard;